export default {
  translations: {
    login: {
      LOGIN_TITLE: '',
      LOGIN_SUBTITLE: '',
      LOGIN_SIGNUP_LINK: '',
      LOGIN_DIVIDER: '',
      LOGIN_FORGOT_PASS: '',
      LOGIN_SUBMIT_BTN: '',
    },
    signup: {
      SIGNUP_TITLE: '',
      SIGNUP_SUBTITLE: '',
      SIGNUP_SIGNUP_LINK: '',
      SIGNUP_DIVIDER: '',
      SIGNUP_SUBMIT_BTN: '',
    },
    resetPassEmail: {
      RESET_PASS_EMAIL_TITLE: '',
      RESET_PASS_SUBTITLE: '',
      FORGET_SUBMIT_BTN: '',
      ALERT_SUCCESS: '',
    },
    resetPass: {
      RESET_PASS_TITLE: '',
      RESET_PASS_SUBTITLE: '',
      RESET_SUBMIT_BTN: '',
      ALERT_SUCCESS: '',
    },
    noContent: {
      NO_CONTENT_PROP_TITLE: '',
      NO_CONTENT_PROP_SUBTITLE: '',
    },
    wishList: {
      NO_SAVED_PROP_TITLE: '',
      NO_SAVED_PROP_SUBTITLE: '',
    },
    savedSearch: {
      ADD_SAVED_SEARCH_LABEL: '',
      NO_SAVED_SEARCH_TITLE: '',
      NO_SAVED_SEARCH_SUBTITLE: '',
      ADD_SAVED_SEARCH_MODAL_TITLE: '',
      VIEW_RESULTS_TEXT: '',
      EDIT_RESULTS_TEXT: '',
      DELETE_SEARCH_TEXT: '',
      STOP_ALERTS_TEXT: '',
    },
    valuationCard: {
      VALUE_PROPERTY: '',
      VALUE_PROPERTY_TEXT: '',
      VALUATION_CTA_BUTTON: '',
    },
    property: {
      // BEDROOM: '',
      // BEDROOMS: '',
      // BATHROOM: '',
      // BATHROOMS: '',
      // RECEPTION: '',
      // RECEPTIONS: '',
    },
    notFoundPage: {
      ERROR_404_TITLE: '',
      ERROR_404_SUB_TITLE: '',
      ERROR_BTN_LABEL: '',
    },
    ourServicesModule: {
      SERVICES_TITLE: '',
    },
    videoModule: {
      VIDEOMODULE_TITLE: '',
    },
    bookViewingModal: {
      BOOK_VIEWING_BUTTON_LABEL: '',
    },
    footer: {
      SITE_BY: '',
    },
  },
};
